import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  FormFeedback,
} from "reactstrap"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import * as Yup from "yup"
import { useFormik } from "formik"
import moment from "moment"
import ErrorPopup from "components/ErrorPopup"
import { addBazaar, fetchBazaarList, fetchAddOnItemList } from "../../../redux/actions/pvs"
import { useDispatch, useSelector } from "react-redux"
import { ADD_BAZAAR_RESET } from "../../../redux/types/pvs"
import { useNavigate } from "react-router-dom"
import PageLoader from "components/Common/PageLoader"
import { toast } from "react-toastify"

const AddBazaar = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [addStall, setAddStall] = useState([])
  const [selectedStalls1, setSelectedStalls1] = useState([])
  const [addOns, setAddOns] = useState([])
  const addOnsRef = useRef([])
  const [selectedStalls, setSelectedStalls] = useState([])
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  // const [inputValue, setInputValue] = useState("")

  const createOption = value => ({ label: value, value })

  const [inputValue, setInputValue] = useState("")

  const addBazaarScreen = useSelector(state => state.screens.pvs.addBazaar)
  const bazaarList = useSelector(state => state.pvs.bazaarList)
  const addOnItemList = useSelector(state => state.pvs.addOnItemList)
  const token = useSelector(state => state.auth.token)

  useEffect(() => {
    addOnsRef.current = addOns
  }, [addOns])

  useEffect(() => {
    dispatch(fetchBazaarList({ offset: 1 }, token))
    dispatch(fetchAddOnItemList())
  }, [])

  const resolveAddonId = opt => {
    const idFields = ["item_id", "id", "add_on_id", "stall_add_on_id", "enc_add_on_id", "enc_item_id", "value"]
    for (let i = 0; i < idFields.length; i++) {
      const v = opt[idFields[i]]
      if (v !== null && v !== undefined) return v
    }
    // Fallback: first primitive property that isn't the item name
    const nameVal = opt.item_name || opt.name || opt.label || ""
    const keys = Object.keys(opt)
    for (let i = 0; i < keys.length; i++) {
      const v = opt[keys[i]]
      if (v !== null && v !== undefined && typeof v !== "object" && v !== nameVal) return v
    }
    return null
  }

  useEffect(() => {
    if (addOnItemList.length > 0 && addOns.length === 0) {
      const first = addOnItemList[0]
      setAddOns([{
        item_id: resolveAddonId(first),
        item_name: first.item_name || first.name || "",
        item_cost: "",
      }])
    }
  }, [addOnItemList])

  useEffect(() => {
    if (addBazaarScreen.success) {
      toast.success(addBazaarScreen.message)
      dispatch({ type: ADD_BAZAAR_RESET })
      // navigate(`/slots-list?id=${row.id}`, {})
      navigate(-1)
    }
    if (addBazaarScreen.error) {
      toast.error(addBazaarScreen.error)
      dispatch({ type: ADD_BAZAAR_RESET })
    }
  }, [addBazaarScreen])

  const formik = useFormik({
    initialValues: {
      bazaar_name: "",
      location: "",
      start_date: "",
      end_date: "",
      booking_date: "",
      description: "",
      enc_combine_bazaar_id: "",
    },

    validationSchema: Yup.object({
      bazaar_name: Yup.string().required("Bazaar name is required"),
      location: Yup.string().required("Location is required"),
      // enc_combine_bazaar_id: Yup.string().required("Group Bazaar is required"),

      start_date: Yup.date()
        .required("Start date is required")
        .typeError("Start date is required"),

      end_date: Yup.date()
        .required("End date is required")
        .typeError("End date is required")
        .min(Yup.ref("start_date"), "End date must be after start date"),

      booking_date: Yup.date()
        .required("Booking date is required")
        .typeError("Booking date is required"),

      description: Yup.string().required("Description is required"),
    }),

    onSubmit: values => {
      let requestBody = {
        bazaar_name: values.bazaar_name,
        start_date: moment(values.start_date.toString()).format("YYYY-MM-DD"),
        end_date: moment(values.end_date.toString()).format("YYYY-MM-DD"),
        booking_date: moment(values.booking_date.toString()).format(
          "YYYY-MM-DD"
        ),
        location: values.location,
        description: values.description,
        enc_combine_bazaar_id: values.enc_combine_group_id,
        stalls: [],
        add_ons: addOnsRef.current
          .filter(item => item.item_id !== null && item.item_id !== undefined)
          .map(item => ({
            item_id: item.item_id,
            item_total_cost: Number(item.item_cost) || 0,
          })),
      }
      if (selectedStalls.length > 0) {
        requestBody.stalls = selectedStalls
      } else {
        setIsErrorOpen(true)
        setIsErrorMessage("Please add at least one stall")
        return
      }
      console.log("requestBody", requestBody)

      dispatch(addBazaar(requestBody))
    },
  })

  const formikStall = useFormik({
    initialValues: {
      stall_type: "",
      stall_size: "",
      stall_numbers: [],
      base_price: "",
      sided_price: "",
      stall_cost: "",
      stall_descr: "",
    },

    validationSchema: Yup.object({
      stall_type: Yup.string().required("Stall Type is required"),
      stall_size: Yup.string().required("Stall Size is required"),
      stall_number: Yup.array().min(1, "At least one stall number is required"),
      base_price: Yup.number().required("Base price is required"),
      // sided_price: Yup.number().required("Sided price is required"),
      stall_cost: Yup.number().required("Stall cost is required"),
    }),

    onSubmit: values => {
      let tempSelectedStalls = [...selectedStalls]
      // log("tempSelectedStalls..", tempSelectedStalls)
      let stallNumbers = []
      values.stall_numbers.map(val => {
        stallNumbers.push(val.value)
      })
      values.stall_numbers = stallNumbers
      values.sided_price = values.sided_price > 0 ? values.sided_price : 0
      let newValues = {
        stall_type: values.stall_type,
        stall_number: values.stall_numbers,
        stall_size: values.stall_size,
        base_price: values.base_price,
        two_sides_price: values.sided_price,
        stall_cost: values.stall_cost,
        gst: 18, //percentage
        description: values.stall_descr,
      }
      tempSelectedStalls.push(newValues)
      setSelectedStalls(tempSelectedStalls)
      formikStall.setValues({
        stall_type: "",
        stall_size: "",
        stall_numbers: [],
        base_price: "",
        sided_price: "",
        stall_cost: "",
        stall_descr: "",
      })
      formikStall.setErrors({})
      formikStall.setTouched({})
    },
  })

  const handleInputChange = value => {
    setInputValue(value)
  }

  const handleStallChange = (newValue, actionMeta) => {
    if (
      actionMeta.action === "clear" ||
      actionMeta.action === "remove-value" ||
      actionMeta.action === "pop-value"
    ) {
      formikStall.setFieldValue("stall_numbers", newValue || [])
      return
    }

    if (!inputValue) return

    const values = inputValue
      .split(/[, \n]+/) // split by comma, space, newline
      .map(v => v.trim())
      .filter(Boolean)

    const newOptions = values.map(createOption)

    let currentStalls = formikStall.values.stall_numbers || []
    let merged = [
      ...currentStalls,
      ...newOptions.filter(
        opt => !currentStalls.some(e => e.value === opt.value)
      ),
    ]

    formikStall.setFieldValue("stall_numbers", merged)

    setInputValue("")
  }

  const handleKeyDown = event => {
    if (!inputValue) return

    // Trigger when user presses Enter or pastes with comma
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()

      const values = inputValue
        .split(/[, \n]+/) // split by comma, space, newline
        .map(v => v.trim())
        .filter(Boolean)

      const newOptions = values.map(createOption)

      let currentStalls = formikStall.values.stall_numbers || []
      let merged = [
        ...currentStalls,
        ...newOptions.filter(
          opt => !currentStalls.some(e => e.value === opt.value)
        ),
      ]

      formikStall.setFieldValue("stall_numbers", merged)

      setInputValue("")
    }
  }

  const handlePaste = event => {
    event.preventDefault()

    const pastedText = event.clipboardData.getData("text")

    const values = pastedText
      .split(/[, \n]+/)
      .map(v => v.trim())
      .filter(Boolean)

    const newOptions = values.map(createOption)

    // setSelectedStalls1(prev => {
    //   const existing = prev.map(p => p.value)
    //   const filtered = newOptions.filter(opt => !existing.includes(opt.value))
    //   return [...prev, ...filtered]
    // })

    let currentStalls = formikStall.values.stall_numbers || []
    let merged = [
      ...currentStalls,
      ...newOptions.filter(
        opt => !currentStalls.some(e => e.value === opt.value)
      ),
    ]
    formikStall.setFieldValue("stall_numbers", merged)
  }

  const handleAddOnSelect = (index, option) => {
    const updated = [...addOns]
    updated[index] = Object.assign({}, updated[index], {
      item_id: option ? option.value : null,
      item_name: option ? option.label : "",
    })
    setAddOns(updated)
  }

  const handleAddOnChange = (index, field, value) => {
    const updated = [...addOns]
    updated[index] = Object.assign({}, updated[index], { [field]: value })
    setAddOns(updated)
  }

  const handleAddOnAdd = () => {
    setAddOns([...addOns, { item_name: "", item_cost: "" }])
  }

  const handleAddOnRemove = index => {
    const updated = [...addOns]
    updated.splice(index, 1)
    setAddOns(updated)
  }

  const handleDeleteStall = index => {
    let temparr = [...selectedStalls]
    temparr.splice(index, 1)
    setSelectedStalls(temparr)
  }

  // useEffect(() => {
  // }, [formikStall])

  document.title = "Add Bazaar | PULA"
  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between mb-3"></div>

        <Form
          className="mt-4"
          onSubmit={e => {
            e.preventDefault()
            formik.handleSubmit()
            return false
          }}
          action="#"
        >
          {/* Bazaar Details */}
          <Card>
            <CardBody>
              <div>
                <h4 className="font-size-18 mb-3 mt-3">Bazaar Details</h4>
                <div className="border-top mt-3 pb-4 mb-1"></div>
                <Form>
                  <div className="row">
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="keywords">
                          Bazaar Name&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="bazaar_name"
                          className="form-control"
                          placeholder="Enter Bazaar Name"
                          type="text"
                          id="bazaar_name"
                          onChange={formik.handleChange}
                          value={formik.values.bazaar_name || ""}
                          invalid={
                            formik.touched.bazaar_name &&
                            formik.errors.bazaar_name
                              ? true
                              : false
                          }
                        />
                        {formik.touched.bazaar_name &&
                        formik.errors.bazaar_name ? (
                          <FormFeedback type="invalid">
                            {formik.errors.bazaar_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="location">
                          Location&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="location"
                          className="form-control"
                          placeholder="Enter location"
                          type="text"
                          id="location"
                          onChange={formik.handleChange}
                          value={formik.values.location || ""}
                          invalid={
                            formik.touched.location && formik.errors.location
                              ? true
                              : false
                          }
                        />
                        {formik.touched.location && formik.errors.location ? (
                          <FormFeedback type="invalid">
                            {formik.errors.location}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="enc_combine_bazaar_id">
                          Group Bazaar&nbsp;
                          {/* <span className="text-danger">*</span> */}
                        </Label>
                        <Select
                          id="enc_combine_bazaar_id"
                          placeholder="Select Group Bazaar"
                          options={bazaarList.map(item => ({
                            label: item.bazaar_name,
                            value: item.combine_group_id,
                            combine_group_id: item.combine_group_id,
                          }))}
                          value={
                            formik.values.enc_combine_bazaar_id
                              ? bazaarList
                                  .map(item => ({
                                    label: item.bazaar_name,
                                    value: item.combine_group_id,
                                    combine_group_id: item.combine_group_id,
                                  }))
                                  .find(
                                    opt =>
                                      opt.value ===
                                      formik.values.enc_combine_bazaar_id
                                  ) || null
                              : null
                          }
                          onChange={option =>
                            formik.setFieldValue(
                              "enc_combine_bazaar_id",
                              (option && option.combine_group_id) || ""
                            )
                          }
                          classNamePrefix="select"
                        />
                        {formik.touched.enc_combine_bazaar_id &&
                        formik.errors.enc_combine_bazaar_id ? (
                          <div className="text-danger font-size-12 mt-1">
                            {formik.errors.enc_combine_bazaar_id}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {/* ================= START DATE ================= */}
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="start_date">
                          Start Date&nbsp;
                          <span className="text-danger">*</span>
                        </Label>

                        <Flatpickr
                          id="start_date"
                          className={`form-control d-block ${
                            formik.touched.start_date &&
                            formik.errors.start_date
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="MM DD, YYYY"
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                          }}
                          value={formik.values.start_date}
                          onChange={date =>
                            formik.setFieldValue("start_date", date[0])
                          }
                          onClose={() =>
                            formik.setFieldTouched("start_date", true)
                          }
                        />

                        {formik.touched.start_date &&
                        formik.errors.start_date ? (
                          <FormFeedback className="d-block" type="invalid">
                            {formik.errors.start_date}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    {/* ================= END DATE ================= */}
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="end_date">
                          End Date&nbsp;
                          <span className="text-danger">*</span>
                        </Label>

                        <Flatpickr
                          id="end_date"
                          className={`form-control d-block ${
                            formik.touched.end_date && formik.errors.end_date
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="MM DD, YYYY"
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                          }}
                          value={formik.values.end_date}
                          onChange={date =>
                            formik.setFieldValue("end_date", date[0])
                          }
                          onClose={() =>
                            formik.setFieldTouched("end_date", true)
                          }
                        />

                        {formik.touched.end_date && formik.errors.end_date ? (
                          <FormFeedback className="d-block" type="invalid">
                            {formik.errors.end_date}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {/* ================= BOOKING DATE ================= */}
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="booking_date">
                          Booking Date&nbsp;
                          <span className="text-danger">*</span>
                        </Label>

                        <Flatpickr
                          id="booking_date"
                          className={`form-control d-block ${
                            formik.touched.booking_date &&
                            formik.errors.booking_date
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="MM DD, YYYY"
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                          }}
                          value={formik.values.booking_date}
                          onChange={date =>
                            formik.setFieldValue("booking_date", date[0])
                          }
                          onClose={() =>
                            formik.setFieldTouched("booking_date", true)
                          }
                        />

                        {formik.touched.booking_date &&
                        formik.errors.booking_date ? (
                          <FormFeedback className="d-block" type="invalid">
                            {formik.errors.booking_date}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="description">
                          Description&nbsp;
                          <span className="text-danger">*</span>
                        </Label>

                        <textarea
                          name="description"
                          id="description"
                          className={`form-control ${
                            formik.touched.description &&
                            formik.errors.description
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="5"
                          placeholder="Enter Description"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.description || ""}
                        />

                        {formik.touched.description &&
                        formik.errors.description ? (
                          <FormFeedback type="invalid">
                            {formik.errors.description}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </CardBody>
          </Card>

          {/* Stall Details */}
          <Card>
            <CardBody>
              <div className="row">
                <div className="col-12 col-sm-6">
                  <h4 className="nom-title">Stall Details</h4>
                </div>
                <div className="col-12 col-sm-6 d-flex justify-content-end align-items-center">
                  <Button
                    onClick={() => {
                      // handleAddStallOnClick()
                      formikStall.handleSubmit()
                    }}
                    color="primary"
                    size="md"
                    className="mt-3 mt-lg-0"
                  >
                    Add Stall +
                  </Button>
                </div>
              </div>
              <div className="border-top pb-4 mb-1"></div>

              <Form>
                <div className="first-stalldetails">
                  <div className="row">
                    {/* STALL TYPE */}
                    <div className="col-12 col-md-6 col-lg-6 col-xl-2">
                      <div className="form-group mb-3">
                        <Label className="form-label">
                          Stall Type&nbsp;<span className="text-danger">*</span>
                        </Label>

                        <Input
                          name="stall_type"
                          value={formikStall.values.stall_type}
                          onChange={formikStall.handleChange}
                          onBlur={formikStall.handleBlur}
                          className={`form-control ${
                            formikStall.stall_type && formikStall.stall_type
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="Stall Type"
                          invalid={
                            formikStall.touched.stall_type &&
                            formikStall.errors.stall_type
                              ? true
                              : false
                          }
                        />
                        {formikStall.touched.stall_type &&
                        formikStall.errors.stall_type ? (
                          <FormFeedback type="invalid">
                            {formikStall.errors.stall_type}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    {/* STALL SIZE */}
                    <div className="col-12 col-md-6 col-lg-6 col-xl-2">
                      <div className="form-group mb-3">
                        <Label className="form-label">
                          Stall Size&nbsp;<span className="text-danger">*</span>
                        </Label>

                        <Input
                          name="stall_size"
                          value={formikStall.values.stall_size}
                          onChange={formikStall.handleChange}
                          onBlur={formikStall.handleBlur}
                          className={`form-control ${
                            formikStall.stall_size && formikStall.stall_size
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="Stall Size"
                          invalid={
                            formikStall.touched.stall_size &&
                            formikStall.errors.stall_size
                              ? true
                              : false
                          }
                        />
                        {formikStall.touched.stall_size &&
                        formikStall.errors.stall_size ? (
                          <FormFeedback type="invalid">
                            {formikStall.errors.stall_size}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    {/* STALL DESCRIPTION */}
                    <div className="col-12 col-md-6 col-lg-6 col-xl-3">
                      <div className="form-group mb-3">
                        <Label className="form-label">Stall Description</Label>

                        <textarea
                          name="stall_descr"
                          value={formikStall.values.stall_descr}
                          onChange={formikStall.handleChange}
                          className="form-control"
                          rows="1"
                          placeholder="Description"
                          invalid={
                            formikStall.touched.stall_descr &&
                            formikStall.errors.stall_descr
                              ? true
                              : false
                          }
                        />
                        {formikStall.touched.stall_descr &&
                        formikStall.errors.stall_descr ? (
                          <FormFeedback type="invalid">
                            {formikStall.errors.stall_descr}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    {/* STALL NUMBERS */}
                    <div className="col-12 col-md-6 col-lg-6 col-xl-5 d-flex">
                      <div className="form-group mb-3 flex-grow-1">
                        <Label className="form-label">
                          Stall Number&nbsp;
                          <span className="text-danger">*</span>
                        </Label>

                        <CreatableSelect
                          isMulti
                          placeholder="Paste & Enter"
                          options={[]} // no options in dropdown
                          value={formikStall.values.stall_numbers}
                          inputValue={inputValue}
                          onInputChange={handleInputChange}
                          onKeyDown={handleKeyDown}
                          onPaste={handlePaste}
                          onChange={handleStallChange}
                          classNamePrefix="select"
                          formatCreateLabel={inputValue =>
                            `Add "${inputValue}"`
                          } // optional, custom create label
                          invalid={
                            formikStall.touched.stall_numbers &&
                            formikStall.errors.stall_numbers
                              ? true
                              : false
                          }
                        />

                        {formikStall.touched.stall_numbers &&
                        formikStall.errors.stall_numbers ? (
                          <FormFeedback type="invalid">
                            {formikStall.errors.stall_numbers}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {/* BASE PRICE */}
                    <div className="col-12 col-lg-3">
                      <div className="form-group mb-3">
                        <Label className="form-label">
                          Base Price&nbsp;<span className="text-danger">*</span>
                        </Label>

                        <Input
                          name="base_price"
                          value={formikStall.values.base_price}
                          type="number"
                          onChange={e => {
                            formikStall.setFieldValue(
                              "base_price",
                              Number(e.target.value)
                            )
                            formikStall.setFieldValue(
                              "stall_cost",
                              Number(e.target.value) +
                                Number(formikStall.values.sided_price)
                            )
                          }}
                          onBlur={formikStall.handleBlur}
                          className={`form-control ${
                            formikStall.base_price && formikStall.base_price
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="Base Price"
                          invalid={
                            formikStall.touched.base_price &&
                            formikStall.errors.base_price
                              ? true
                              : false
                          }
                        />

                        {formikStall.touched.base_price &&
                        formikStall.errors.base_price ? (
                          <FormFeedback type="invalid">
                            {formikStall.errors.base_price}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    {/* 2 SIDED PRICE */}
                    <div className="col-12 col-lg-3">
                      <div className="form-group mb-3">
                        <Label className="form-label">Two Sided Price</Label>

                        <Input
                          name="sided_price"
                          value={formikStall.values.sided_price}
                          type="number"
                          onChange={e => {
                            formikStall.setFieldValue(
                              "sided_price",
                              Number(e.target.value)
                            )
                            formikStall.setFieldValue(
                              "stall_cost",
                              Number(formikStall.values.base_price) +
                                Number(e.target.value)
                            )
                          }}
                          className="form-control"
                          placeholder="Two Sided Price"
                          invalid={
                            formikStall.touched.sided_price &&
                            formikStall.errors.sided_price
                              ? true
                              : false
                          }
                        />
                        {formikStall.touched.sided_price &&
                        formikStall.errors.sided_price ? (
                          <FormFeedback type="invalid">
                            {formikStall.errors.sided_price}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    {/* STALL COST */}
                    <div className="col-12 col-lg-3">
                      <div className="form-group mb-3">
                        <Label className="form-label">
                          Stall Cost&nbsp;<span className="text-danger">*</span>
                        </Label>

                        <Input
                          name="stall_cost"
                          value={formikStall.values.stall_cost}
                          type="number"
                          onChange={e => {
                            formik.setFieldValue(
                              "stall_cost",
                              Number(e.target.value)
                            )
                          }}
                          onBlur={formikStall.handleBlur}
                          className={`form-control ${
                            formikStall.values.stall_cost &&
                            formikStall.values.stall_cost
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="Stall Cost"
                          invalid={
                            formikStall.touched.stall_cost &&
                            formikStall.errors.stall_cost
                              ? true
                              : false
                          }
                        />

                        {formikStall.touched.stall_cost &&
                        formikStall.errors.stall_cost ? (
                          <FormFeedback type="invalid">
                            {formikStall.errors.stall_cost}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>

                {selectedStalls.length > 0 && (
                  <div className="table-responsive mt-3 mb-5">
                    <table className="table table-bordered table-striped table-sm">
                      <thead className="table-light">
                        <tr>
                          <th>Stall Type</th>
                          <th>Stall Size</th>
                          <th>Description</th>
                          <th>{`Stall Numbers ( Total: ${selectedStalls
                            .reduce(
                              (sum, val) =>
                                sum + Number(val.stall_number.length),
                              0
                            )
                            .toLocaleString()} )`}</th>
                          <th>Base Price</th>
                          <th>2 Sided Price</th>
                          <th>Stall Cost</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedStalls.map((stall, index) => (
                          <tr key={index}>
                            <td>{stall.stall_type}</td>
                            <td>{stall.stall_size}</td>
                            <td style={{ maxWidth: "200px" }}>
                              {stall.description}
                            </td>
                            <td style={{ maxWidth: "200px" }}>
                              {stall.stall_number.join(", ")}
                            </td>
                            <td>{stall.base_price}</td>
                            <td>{stall.two_sides_price}</td>
                            <td>{stall.stall_cost}</td>
                            <td>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => handleDeleteStall(index)}
                                title="Delete"
                                aria-label="Delete payment"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  style={{ marginRight: 6 }}
                                >
                                  <polyline points="3 6 5 6 21 6"></polyline>
                                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                  <path d="M10 11v6"></path>
                                  <path d="M14 11v6"></path>
                                  <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
                                </svg>
                              </Button>
                            </td>
                          </tr>
                        ))}
                        {/* <tr className="table-primary fw-bold">
                      <td colSpan="8" className="text-center">
                        {`Total Stalls: `}
                      </td>
                    </tr> */}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="row">
                  <div className="col-12 col-sm-6">
                    <h4 className="nom-title">Add-Ons</h4>
                  </div>
                  <div className="col-12 col-sm-6 d-flex justify-content-end align-items-center">
                    <Button
                      onClick={handleAddOnAdd}
                      color="primary"
                      size="md"
                      className="mt-3 mt-lg-0"
                    >
                      Add Items +
                    </Button>
                  </div>
                </div>
                <div className="border-top pb-4 mb-1"></div>
                {addOns.map((item, index) => {
                  const addonOptions = addOnItemList.map(opt => ({
                    value: resolveAddonId(opt),
                    label: opt.item_name || opt.name || "",
                  }))
                  const selectedAddon = addonOptions.find(opt => opt.value == item.item_id) || null
                  return (
                  <div key={index} className="row align-items-end mb-2">
                    <div className="mb-3 col-12 col-sm-5 col-lg-4">
                      <label className="form-label">Item Name</label>
                      <Select
                        placeholder="Select Item"
                        options={addonOptions}
                        value={selectedAddon}
                        onChange={option => handleAddOnSelect(index, option)}
                        classNamePrefix="select"
                      />
                    </div>
                    <div className="mb-3 col-12 col-sm-5 col-lg-4">
                      <label className="form-label">Item Cost</label>
                      <Input
                        type="number"
                        placeholder="Enter Item Cost"
                        value={item.item_cost}
                        onChange={e =>
                          handleAddOnChange(index, "item_cost", e.target.value)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-12 col-sm-2 col-lg-1 mb-3 pb-1">
                      <Button
                        onClick={() => handleAddOnRemove(index)}
                        type="button"
                        size="sm"
                        color="danger"
                      >
                        <i className="mdi mdi-delete"></i>
                      </Button>
                    </div>
                  </div>
                  )
                })}
              </Form>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-center mt-4">
            <Button
              type="submit"
              color="primary"
              className="w-20 btn btn-block font-size-16 mt-3"
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="Fix following errors"
        message={isErrorMessage}
      />
      <PageLoader open={addBazaarScreen.loading} />
    </div>
  )
}

export default AddBazaar
